module.exports = __webpack_public_path__ + "img/low-sq.af1fcf33.svg";